import React from 'react'
import { If, Then, Else } from 'react-if';
import store from "../../../store"
import PropTypes from 'prop-types';

export const checkPermission = (action, subjectClass, operator = 'OR') => {
  if(action === "" || action === true || action === 'true'){
    return true;
  } else if(action === false || action === 'false'){
    return false;
  }

  let can = undefined;
  if(localStorage.getItem("accessToken") !== null){
    let ownedSubjectClasses = [];

    const permissions = store.getState().viewConfig.profile.attributes.permissions;
    const requiredActions = action.split(',');
    const requiredSubjectClasses = subjectClass.split(',');
    requiredActions.forEach((action) => {
      let subjects = permissions.can[action];
      if(subjects) {
        ownedSubjectClasses = ownedSubjectClasses.concat(subjects);
      } else if(operator === 'AND'){
        can = false;
      }
    });

    if(can === undefined){
      if(operator === 'OR'){
        can = requiredSubjectClasses.some((subj) => ownedSubjectClasses.find(owned => owned === subj));
      } else {
        can = requiredSubjectClasses.every((subj) => ownedSubjectClasses.find(owned => owned === subj));
      }
    }
  }

  return !!can;
};

const Can = ({action, subjectClass, operator, cannot, children}) => {
  const can = checkPermission(action, subjectClass, operator);

  return (
    <If condition={can}>
      <Then>
        <div>
          {children}
        </div>
      </Then>
      <Else>
        <div>
          {cannot}
        </div>
      </Else>
    </If>
  )
};

Can.propTypes = {
  action: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  subjectClass: PropTypes.string,
  operator: PropTypes.oneOf(['OR','AND']),
  cannot: PropTypes.any
};

Can.defaultProps = {
  operator: 'OR'
};


export default Can


// WEBPACK FOOTER //
// ./src/components/common/guards/can.jsx